/* eslint-disable no-dupe-keys */
import { getRequiredFields } from 'utils/form'

const fields = [
  {
    label: 'Account',
    name: 'account',
    layout: 'fullWidth',
    maxLength: 5,
    validators: [
      {
        check: 'required',
        check: 'requiredNumber',
      },
    ],
    error: 'Please enter an account to lock',
  },    
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/LockedAccountForm.js